module.exports = "/assets/data/6c6fcce77561e1f736f7e2b3a105aea6-SA43.data.json";